import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL.replace(/\/$/, '')}/api`;

const fmtDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

const ProposalConfirm = () => {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, error: null, proposal: null, request: null });
  const [responding, setResponding] = useState(false);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/proposals/${token}`)
      .then(r => setState({ loading: false, error: null, proposal: r.data.proposal, request: r.data.request }))
      .catch(e => setState({ loading: false, error: e?.response?.data?.detail || 'Eroare', proposal: null, request: null }));
  }, [token]);

  const respond = async (accept) => {
    setResponding(true);
    try {
      const r = await axios.post(`${API}/proposals/${token}/respond`, { accept });
      setResponse({ accept, alreadyResponded: r.data.already_responded });
    } catch (e) {
      setResponse({ error: e?.response?.data?.detail || 'Eroare' });
    } finally {
      setResponding(false);
    }
  };

  if (state.loading) return <div style={styles.page}><div style={styles.card}>Se încarcă...</div></div>;

  if (state.error) return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Propunere indisponibilă</h1>
        <p>{state.error}</p>
      </div>
    </div>
  );

  const { proposal, request } = state;
  const isPending = proposal.status === 'pending';

  if (response?.accept === true) return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.h1}>✅ Rezervare confirmată!</h1>
        <p style={{ fontSize: 18 }}>Te așteptăm pe <strong>{fmtDate(proposal.date)}</strong> la ora <strong>{proposal.time}</strong>.</p>
        <p>Vino cu 10 minute înainte. La revedere!</p>
      </div>
    </div>
  );

  if (response?.accept === false) return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Ai refuzat propunerea</h1>
        <p>Mulțumim că ne-ai răspuns. Te rugăm să iei legătura cu noi pentru a găsi o altă oră potrivită.</p>
      </div>
    </div>
  );

  if (!isPending) return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Propunere {proposal.status === 'expired' ? 'expirată' : 'deja finalizată'}</h1>
        <p>Această propunere {proposal.status === 'expired' ? 'a expirat' : `este ${proposal.status}`}. Te rugăm să ne contactezi.</p>
      </div>
    </div>
  );

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Propunere rezervare</h1>
        <p style={{ color: '#aaa' }}>Salut{request?.client_name ? `, ${request.client_name}` : ''}!</p>
        <p style={{ marginBottom: 18 }}>Îți confirmăm propunerea de rezervare:</p>

        <div style={styles.detail}>
          <div style={styles.detailRow}><span style={styles.label}>Activitate:</span> <strong>{proposal.game_type === 'paintball' ? 'Paintball' : 'Lasertag'}</strong></div>
          {proposal.package && <div style={styles.detailRow}><span style={styles.label}>Pachet:</span> <strong>{proposal.package}</strong></div>}
          <div style={styles.detailRow}><span style={styles.label}>Data:</span> <strong>{fmtDate(proposal.date)}</strong></div>
          <div style={styles.detailRow}><span style={styles.label}>Ora:</span> <strong>{proposal.time}</strong></div>
        </div>

        <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
          <button style={styles.btnAccept} disabled={responding} onClick={() => respond(true)}>
            ✓ ACCEPT
          </button>
          <button style={styles.btnReject} disabled={responding} onClick={() => respond(false)}>
            ✗ REFUZ
          </button>
        </div>

        <p style={{ marginTop: 18, fontSize: 13, color: '#888' }}>
          Slotul este rezervat pentru tine până când răspunzi sau până la expirare.
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: { minHeight: '60vh', background: '#0f0f14', color: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  card: { background: '#1a1a22', padding: 32, borderRadius: 14, maxWidth: 480, width: '100%', border: '1px solid #2a2a35', boxShadow: '0 8px 32px rgba(0,0,0,0.4)' },
  h1: { fontSize: 26, marginBottom: 12, color: '#d9fb06' },
  detail: { background: '#0f0f14', padding: 16, borderRadius: 8, border: '1px solid #2a2a35' },
  detailRow: { padding: '6px 0', borderBottom: '1px dashed #333' },
  label: { color: '#888', marginRight: 10 },
  btnAccept: { flex: 1, background: '#22c55e', color: '#000', border: 'none', borderRadius: 8, padding: '14px 0', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  btnReject: { flex: 1, background: '#ef4444', color: '#fff', border: 'none', borderRadius: 8, padding: '14px 0', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
};

export default ProposalConfirm;
